import { z } from "zod"

export const PaginationMetaSchema = z
	.object({
		page: z.number().int().positive(),
		limit: z.number().int().positive(),
		total: z.number().int(),
		totalPages: z.number().int(),
	})
	.meta({ id: "PaginationMeta" })

export type PaginationMeta = z.infer<typeof PaginationMetaSchema>

export function createPaginatedResponseSchema<T extends z.ZodType>(itemSchema: T) {
	return z.object({
		data: z.array(itemSchema),
		meta: PaginationMetaSchema,
	})
}

export function createDetailResponseSchema<T extends z.ZodType>(itemSchema: T) {
	return z.object({
		data: itemSchema,
	})
}

export const ApiErrorSchema = z
	.object({
		error: z.object({
			code: z.string(),
			message: z.string(),
		}),
	})
	.meta({ description: "Standard API error envelope", id: "ApiError" })

export type ApiError = z.infer<typeof ApiErrorSchema>
